
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.25 18a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zm7.5 3a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zm0-7.5a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zm-3.325 3.345l3.65-2.19m-3.487 4.18l3.325 1.33M3 3.75a3 3 0 106 0 3 3 0 10-6 0zm8.2 8.999A5.251 5.251 0 00.75 13.5v2.25H3l.75 7.5h4.5l.2-2.015m5.425-17.86a2.625 2.625 0 105.25 0 2.625 2.625 0 10-5.25 0zM20.4 9a4.5 4.5 0 00-7.285-.71","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    